import { render, staticRenderFns } from "./DashboardHomeViewDebug.vue?vue&type=template&id=5826d536&scoped=true&"
import script from "./DashboardHomeViewDebug.vue?vue&type=script&lang=js&"
export * from "./DashboardHomeViewDebug.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHomeViewDebug.vue?vue&type=style&index=0&id=5826d536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826d536",
  null
  
)

export default component.exports